import type { FaireProductEntity } from "../../entity_types/product";

export const p_f538p9j4m3: FaireProductEntity = {
  token: "p_f538p9j4m3",
  type: "product",
  name: "Marseille Top (2XS/S - 2M/L)",
  brandToken: "b_85a3118wke",
  brandName: "Le Bon Shoppe",
  imageUrl:
    "https://cdn.faire.com/fastly/04c00960f228bd27a4ab61095dde0390319d38f0dc8549cc7a1d7926e08e7d9c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/bc519a967eebcbd0e1a7c0e2bb47e6f06a812aa09c9df8dd3c384d46bdce98cc.jpeg",
    "https://cdn.faire.com/fastly/eaa1fbb001d6ad438801c5dcb583aaa25459328c82e0f392f61004e712e9f9b1.jpeg",
    "https://cdn.faire.com/fastly/faa2ee1f9a8bcee62a941ad686fa5406f848459aa01a9df82a766e8515c47836.jpeg",
    "https://cdn.faire.com/fastly/572f7e2d1bffaece493cbdfdc65ed20dcdd85542e30fb46cd1943311bd85866b.jpeg",
    "https://cdn.faire.com/fastly/c44ee0e1e6ef9ae5fa26612c67f0fec1060fc4a164a5b75d57943fb384269392.jpeg",
    "https://cdn.faire.com/fastly/44b7a63e683d1d68901a11ca7dd6e2451db2c74e266b955774ef4311b8d0af46.jpeg",
    "https://cdn.faire.com/fastly/60f6795a2cc0d9b41ab8959ac2b5d945ab03b9b8f37680a42b5bdeedfd21c2bd.jpeg",
    "https://cdn.faire.com/fastly/3be85e7e114e06e7999d0092ec05cc1862f6af6a49d366120db830a78e57a7f0.jpeg",
    "https://cdn.faire.com/fastly/c10c5a5afe7beebf82f541245a59747fd30e37f49c88742fcc34d68644aca835.jpeg",
    "https://cdn.faire.com/fastly/b2600a3acc12e497023304d412210470b0aeb05df8507a3dcd2f54e29e9deb6d.jpeg",
    "https://cdn.faire.com/fastly/5682c56dc9e6514b9933c55031ede0170f0f8a8e2eb5706467b4a7c40187646a.jpeg",
    "https://cdn.faire.com/fastly/3133a02d00941924080e4aa0ed5e7bd99c6375a392cabf46ab15f2a490d64622.jpeg",
    "https://cdn.faire.com/fastly/45ba868f4f2d3d3b000d57e990209fd8f902ba4f24de281d396f26736326423c.jpeg",
    "https://cdn.faire.com/fastly/ea4caf8c902582e75bf1f5a4e4266c083dff9cf98dce820483ebc353bae2e67b.jpeg",
    "https://cdn.faire.com/fastly/6a463d930fcf56e06ed215ef249788689eef37fe9906ddbfc38bba3519bb2fd1.jpeg",
    "https://cdn.faire.com/fastly/bd9229bffe24ce1a1890a63f3bbd49b27fb8dff5087b64e02cd9f36d5620c96a.jpeg",
    "https://cdn.faire.com/fastly/2a651409582d27090adcc7f787089d4322c05087474f3955814c674ed390e0c2.jpeg",
  ],
  priceDollars: 192,
  description:
    'Why We Made This?\n\nAdd a touch of Parisian flair to your wardrobe. The Marseille Top takes inspiration from the timeless Breton stripe uniform, featuring a classic round neckline and an oversized, full-length fit that gently sweeps the hips. Crafted from durable, heavyweight cotton, it offers structure without sacrificing softness, making it an ideal choice for both elevated and casual looks.\n\n\n\n\nContents: \n\n100% Cotton Heavy Cotton Stripe\n\n\n\nCare Instructions:\n\n-Machine wash cold with like colors\n-Do not soak\n-Do not spot clean\n-Hang dry for best results or tumble dry on low heat\n\n\n\n\nApproximate Measurements: \n\n\nXS/S : Chest - 21", Length - 26 1/2" \n\nM/L : Chest - 22 1/2" , Length - 27" \n\n\n\nModel is 5\' 6", Bust: 34", Waist: 27", Hip:36" and wearing a size XS/S\n\n\nMade in South Korea \n\n\n\nMSRP: $95 USD\n\n\n\n\n\n',
  tags: [],
  msrpDollars: 380,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-21T21:52:09.942Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
